import { validateDataLayerPayload } from '../shared/data-layer.js';
import type { SchemaInput } from '../shared/schema-input.js';

export const MAX_LOCAL_DATA_LAYER_FEATURES = 300_000;
export const MAX_LOCAL_DATA_LAYER_BYTES = 256 * 1024 * 1024;

export function validateLocalDataLayerPayload(value: SchemaInput, options: { reuseFeatures?: boolean } = {}) {
  return validateDataLayerPayload(value, { ...options, maxFeatures: MAX_LOCAL_DATA_LAYER_FEATURES, maxBytes: MAX_LOCAL_DATA_LAYER_BYTES });
}
